// extracted by mini-css-extract-plugin
export var backButton = "MainHeadline-module--backButton--c79bd";
export var contentSide = "MainHeadline-module--contentSide--693b1";
export var descriptionWrap = "MainHeadline-module--descriptionWrap--df636";
export var featuredEmoji = "MainHeadline-module--featuredEmoji--5b272";
export var headlineWrap = "MainHeadline-module--headlineWrap--21738";
export var mainHeadline = "MainHeadline-module--mainHeadline--d5f1d";
export var root = "MainHeadline-module--root--f73fa";